import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ListDisplayPage } from './list-display.page';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: 'list-display',
        component: ListDisplayPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule,
    ],
    declarations: [ListDisplayPage],
    exports: [ListDisplayPage],
    
})
export class ListDisplayPageModule {}
